import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SegmentSeatAssignment')
export default class SegmentSeatAssignment {
  @JsonProperty('id', Number) public id: number = undefined;
  @JsonProperty('x', String, true) public x: string = undefined;
  @JsonProperty('y', String, true) public y: string = undefined;
  @JsonProperty('z', String, true) public z: string = undefined;
}
